import React from "react";

const CityCardLabel = ({ index, value, max }) => {
  return (
    <div
      className={`h-full w-40 rounded-l-xl border border-white py-1 pl-4 font-bold leading-10 text-slate-100 dark:bg-opacity-20 ${
        [
          "bg-[#1a9850] dark:border-[#1a9850] dark:text-[#1a9850]",
          "bg-[#50b15e] dark:border-[#50b15e] dark:text-[#50b15e]",
          "bg-[#7fc865] dark:border-[#7fc865] dark:text-[#7fc865]",
          "bg-[#abdb6d] dark:border-[#abdb6d] dark:text-[#abdb6d]",
          "bg-[#ceea84] dark:border-[#ceea84] dark:text-[#ceea84]",
          "bg-[#ebea8b] dark:border-[#ebea8b] dark:text-[#ebea8b]",
          "bg-[#fdd682] dark:border-[#fdd682] dark:text-[#fdd682]",
          "bg-[#fdb366] dark:border-[#fdb366] dark:text-[#fdb366]",
          "bg-[#f78750] dark:border-[#f78750] dark:text-[#f78750]",
          "bg-[#eb5a3a] dark:border-[#eb5a3a] dark:text-[#eb5a3a]",
          "bg-[#ff0000] dark:border-[#ff0000] dark:text-[#ff0000]",
          "bg-[#ff0000] dark:border-[#ff0000] dark:text-[#ff0000]",
        ][Math.floor((value * 10) / max)]
      }`}
    >
      {"ABCDEFGHIJKLMNOPQRSTUVWXYZ"[index] + ". " + value}
    </div>
  );
};

export default CityCardLabel;
